export function popups() {
  const body = document.body;
  const container = document.querySelector("main");
  
  if(container == null)
      return;
  
  const sections = container.querySelectorAll("section");
  const popups = document.querySelectorAll(".popup-item");
  const closer = document.querySelector(".close-popup");
  
  if(closer == null)
      return;
  
  const opener = "open-popup";
  const clsOpen = "popup-visible";
  const popupOpened = "opened";
  let openerButtons = $('.open-popup').toArray();
  let parentElements = $("html, body");
  let mainContainer = $(".main");
  let scrollTop;
  let windowWidth = window.innerWidth;

  function createElements(parent, result, className) {
      [].forEach.call(parent, el => {
          if (el.querySelector("." + className)) {
            result.push(el.querySelector("." + className));
          }
      });
  }

  function lockBody() {
      if (window.pageYOffset) {
          scrollTop = window.pageYOffset;
          mainContainer.css({
              top: -(scrollTop)
          });
      }
      parentElements.css({
          height: "100%",
          overflow: "hidden"
      });
  }

  function unlockBody() {
      parentElements.css({
          height: "",
          overflow: ""
      });
      mainContainer.css({
          top: ""
      });
      window.scrollTo(0, scrollTop);
      window.setTimeout(function () {
          scrollTop = null;
      }, 0);
  }

  //createElements(sections, openerButtons, opener);
  
  openerButtons.forEach((el, index) => {
      el.addEventListener("click", e => {
        e.preventDefault()
          if (windowWidth < 1200) {
              lockBody();
          }
          body.classList.add(clsOpen);
          closer.classList.add("active"); 

          var _popup = $('.popup-item[data-postid="'+$(el).data('postid')+'"]');

          if (_popup.length > 0) {
            _popup.find('video').attr('preload', 'auto')
          }
          _popup.addClass(popupOpened)
          
          //popups[index].classList.add(popupOpened);
          
      });
  });

  closer.addEventListener("click", e => {
      closer.classList.remove("active");
      if (windowWidth < 1200) {
          unlockBody();
      }
      [].forEach.call(popups, item => {
          if (item.classList.contains(popupOpened)) {
              item.classList.remove(popupOpened);
          }
      });
      $('.video-wrapper iframe').each(function() {
        $(this).attr('src', $(this).attr('src'));
      });
      $("video").each(function() {
          $(this).get(0).pause();
      });
      setTimeout(function () {
          body.classList.remove(clsOpen);
      }, 800);
      e.preventDefault();
  });
  
  document.addEventListener('keydown', function(e) {
    if(e.keyCode == 27 && $('.close-popup').hasClass('active')) {
      closer.classList.remove("active");
      if (windowWidth < 1200) {
        unlockBody();
      }
      [].forEach.call(popups, item => {
        if (item.classList.contains(popupOpened)) {
          item.classList.remove(popupOpened);
        }
      });
      $('.video-wrapper iframe').each(function() {
        $(this).attr('src', $(this).attr('src'));
      });
      $("video").each(function() {
          $(this).get(0).pause();
      });
      setTimeout(function () {
        body.classList.remove(clsOpen);
      }, 800);

      e.preventDefault();
    }
  });

  $('.popup-item').on('click', function(e) {
    if (e.target !== this)
      return;

    closer.classList.remove("active");
    if (windowWidth < 1200) {
      unlockBody();
    }
    [].forEach.call(popups, item => {
      if (item.classList.contains(popupOpened)) {
        item.classList.remove(popupOpened);
      }
    });
    $('.video-wrapper iframe').each(function() {
      $(this).attr('src', $(this).attr('src'));
    });
    $("video").each(function() {
        $(this).get(0).pause();
    });
    setTimeout(function () {
      body.classList.remove(clsOpen);
    }, 800);

    e.preventDefault();
  });


    if($('#fixed-bagde').length) {

        const now = new Date();   
        const day = 86400;// sec
        const tomorrow = new Date(Date.now() + day * 1000);

        $('#fixed-bagde-close, #fixed-bagde').on('click', function(event) {
            $('#fixed-bagde').remove();
            localStorage.setItem('fixed-bagde',  tomorrow.getTime());
            event.stopPropagation();
        });

        if(!localStorage.getItem('fixed-bagde') || now.getTime() > Number(localStorage.getItem('fixed-bagde'))){
            $('#fixed-bagde').fadeIn(1000);
        }
    }   

}


// WEBPACK FOOTER //
// ./assets/js/modules/popups.js